import {action, extendObservable, decorate} from 'mobx';
import * as R from 'ramda/src/index';
import airportsProvider from 'providers/airports';

class CollapseSearchMaskStore {
  constructor() {
    extendObservable(this, {
      query: {
        dep: '',
        arr: '', 
        obDate: '',
        ibDate: '',
        isRoundtrip: '0',
        passengersAdult: '1',
        passengersChild: '0',
        passengersInfant: '0',
        directFlightsOnly: '0',
        extendedDates: '0'
      }
    });
  }

  setQuery = (query) => {
    this.query = query;
    this.setAirports(query);
  };

  setAirports = ({dep, arr}) => {
    const locations = {dep, arr};
    Object.keys(locations).forEach((key) => {
      const location = locations[key];
      if (location.length === 3) {
        airportsProvider.createAirportsProvider(`${key}-summary`)(location).then(({results}) => {
          const airport = R.find(R.propEq({airportCode: location}))(results);
          if (airport) {
            this.query[key] =
              `${airport.tCity} - ${airport.tAirportName} (${airport.airportCode}), ${airport.tCountryName}`;
          }
        });
      }
    });
  };
}

decorate(CollapseSearchMaskStore, {
  setQuery: action,
  setAirports: action
});

export default CollapseSearchMaskStore;
